<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="SunIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="confirmSetActive" />
      <feather-icon icon="ZapIcon" svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="confirmSetFeatured" />
    </div>
</template>

<script>
    export default {
        name: 'CellRendererActions',
        methods: {
          editRecord() {
            this.$router.push("/apps/competition/competition-edit/" + this.params.data.link).catch(() => {})

          },
          confirmSetActive() {
            if(this.params.data.hasWinner)
            {
              this.$vs.notify({
                color: 'danger',
                title: 'Update Not Performed',
                text: 'This competition has ended and can not be re-activated'
              });
            } else {
              this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm Active State`,
                text: `You are about to toggle this competitions active state`,
                accept: this.setActiveStatus,
                acceptText: "Toggle"
              });
            }
          },
          confirmSetFeatured() {
            if(this.params.data.hasWinner)
            {
              this.$vs.notify({
                color: 'danger',
                title: 'Update Not Performed',
                text: 'This competition has ended and can not be re-featured'
              });
            } else {
              this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirm Featured State`,
                text: `You are about to toggle this competitions featured state`,
                accept: this.setFeaturedStatus,
                acceptText: "Toggle"
              });
            }
          },
          confirmDeleteRecord() {
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirm Delete`,
              text: `You are about to delete "${this.params.data.username}"`,
              accept: this.deleteRecord,
              acceptText: "Delete"
            })
          },
          setActiveStatus() {
            this.$store.dispatch("competition/setActiveStatus", this.params.data.link).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Status could not be changed.',
                text: 'Please contact administrator'
              });
            });

            this.$vs.notify({
              color: 'success',
              title: 'Competition Update',
              text: 'The competitions active status has been toggled'
            });

            setTimeout(() => this.$router.go(this.$router.currentRoute), 1500);
          },
          setFeaturedStatus() {
            this.$store.dispatch("competition/setFeaturedStatus", this.params.data.link).catch(() => {
              this.$vs.notify({
                color: 'danger',
                title: 'Status could not be changed.',
                text: 'Please contact administrator'
              });
            });

            this.$vs.notify({
              color: 'success',
              title: 'Competition Update',
              text: 'The competitions featured status has been toggled'
            });

            setTimeout(() => this.$router.go(this.$router.currentRoute), 1500);
          },
          deleteRecord() {
            /* Below two lines are just for demo purpose */
            this.showDeleteSuccess()

            /* UnComment below lines for enabling true flow if deleting user */
            // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
            //   .then(()   => { this.showDeleteSuccess() })
            //   .catch(err => { console.error(err)       })
          },
          showDeleteSuccess() {
            this.$vs.notify({
              color: 'success',
              title: 'User Deleted',
              text: 'The selected user was successfully deleted'
            })
          }
        }
    }
</script>
